// JWT Authentication - Using real backend API
import { userForgetPasswordSuccess, userForgetPasswordError } from "./reducer";
import { APIClient } from "../../helpers/api_helper";

const API_BASE_URL = (window as any).process?.env?.REACT_APP_API_BASE_URL || 'http://localhost:8080';

export const userForgetPassword = (user: any, history: any) => async (dispatch: any) => {
    try {
        // Use real backend API endpoint for forgot password
        const apiClient = new APIClient();
        const response = await apiClient.create(`${API_BASE_URL}/auth/forgot-password`, { 
            email: user.email 
        });

        if (response) {
            dispatch(userForgetPasswordSuccess(
                "Reset link has been sent to your mailbox. Please check your email."
            ));
        }
    } catch (forgetError: any) {
        const errorMessage = forgetError?.message || "Failed to send reset link. Please try again.";
        dispatch(userForgetPasswordError(errorMessage));
    }
};
